<template>
  <b-col class="m-auto text-center align-items-center">
    <img
      tabindex="-1"
      src="../../assets/login/mail_amarelo.svg"
      alt="Envelope com carta"
      class="w-50 mb-4"
    />

    <h2 class="text-tertiary">
      <span tabindex="0" class="medium">{{
        resources.page.login.password.title
      }}</span>
    </h2>
    <h2 class="text-white">
      <span tabindex="0" class="medium">{{
        resources.page.login.password.description
      }}</span>
    </h2>

    <br />
    <h5 tabindex="0" class="text-white">
      {{ resources.page.login.password.ps
      }}<span tabindex="0" class="text-tertiary">axel@teamculture.com.br</span>
    </h5>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters({
    resources: 'resources',
  }),
}
</script>
